import type { AgentApiCustomFieldsIndex } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchCompaniesCustomFields() {
  return useQuery({
    queryKey: ['CompaniesCustomFields'],
    queryFn: async () => {
      const response = await fetch('/agent/api/companies/custom_fields.json');
      const data: AgentApiCustomFieldsIndex = await response.json();
      return data;
    },
  });
}
